//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapMutations} from 'vuex'

export default {
  name: 'BorgCR10_info',
  data() {
    return {}
  },
  components: {},
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Card/BorgCR10_info.vue